export const secure_env = {
  SCC_BFF_API_KEY:'AKYc9223yZp8WYWHGteI3VjQu1sdNiLzLG7m53O8',
  SCC_GIT_ACCESS_TOKEN: 'glpat-qmSRmaczPL85rBWKV3Coy286MQp1OmtsemplCw.01.120tfgk29',
  SCC_GIT_PROJECT_ID: '47456066',
  SCC_PASS_PHRASE_DEV: 'undefined',
  SCC_PASS_PHRASE_STG: 'undefined',
  SCC_PASS_PHRASE_UAT: 'undefined',
  SCC_PASS_PHRASE_PRD: 'gallows_overload_unrobed_ruse_underrate_replay_geometric_labored_rearrange_repacking_cornflake_copied'
};